/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import classNames from 'classnames/bind'
import { Link } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import { Text } from 'hocs/localization'
import { getPathWithParams } from 'utils/location'
import { MENU_ITEMS, ITEM_NAMES } from './constants'
import * as styles from './Footer.scss'

const cx = classNames.bind(styles)

interface IProps {
  children?: React.ReactNode,
  styleType?: string,
  t: Text,
  onClickMenuItem: (event: React.SyntheticEvent, name: ITEM_NAMES) => void,
}

const resolveFunctionByName = (funcPath) => {
  try {
    return funcPath.split('.').reduce((obj, key) => obj?.[key], window);
  } catch {
    return null;
  }
};

const Footer: React.FC<IProps> = ({
  styleType = 'default',
  t,
  onClickMenuItem,
}) => {
  return (
    <div className={cx(styles.FooterSec, styleType)}>
      <div className='container-fluid'>
        <div className={cx('row', 'footerRow', 'no-gutters')}>
          <div className={cx('col-lg-8', 'col-md-9')}>
            <div className={styles.footermenu}>
              <ul>
                {MENU_ITEMS.map(item => (
                  <li key={item.textPath} className={styles.item}>
                    
                    {(item.action) ? (
                      <a
                        href='#'
                        className={styles.link}
                        onClick={(e) => {
                          e.preventDefault();
                      
                          const func = resolveFunctionByName(item.action);
                          if (typeof func === 'function') {
                            func();
                          } else {
                            console.warn(`Function "${item.action}" not found or not a function`);
                          }
                        }}
                      >
                        {t(`menu.${item.textPath}`)}
                      </a>
                    ) :
                    (
                      <a
                        href={item.linkPath
                          ? t(item.linkPath)
                          : getPathWithParams(ROUTES.home.menu, { menu: item.textPath })}
                        className={styles.link}
                        onClick={event => onClickMenuItem(event, item.name)}
                      >
                        {t(`menu.${item.textPath}`)}
                      </a>
                    )
                  }
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className={cx('col-lg-4', 'col-md-3', 'text-right')}>
            <div className={styles.Readyprint}>
              {t('copyright', { year: new Date().getFullYear() })}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
